function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _ from 'lodash';
import gettext from 'js-utils/gettext';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Icon from '../../icon/Icon';
import Button from '../../button/Button';
import { CUSTOM_NAVIGATION_PROP_TYPE } from '../constants';
import StatusDotChunkySvg from '../../iconography/icons/StatusDotChunky';

var _getNavigationItems = function _getNavigationItems(_ref) {
  var totalItems = _ref.totalItems,
      activeIndex = _ref.activeIndex,
      customNavigation = _ref.customNavigation,
      onClick = _ref.onClick;
  return _.times(totalItems, function (index) {
    var isActive = activeIndex === index;
    var color = isActive ? 'grey-800' : 'grey-300';
    var title = gettext('Slide %(index)s', {
      index: index
    });
    var innerNavigation = React.createElement(Icon, {
      type: React.createElement(StatusDotChunkySvg, null),
      color: color,
      title: title
    });
    var customNavigationItem = customNavigation && customNavigation[index];

    if (customNavigationItem) {
      var base = customNavigationItem.base,
          active = customNavigationItem.active;
      innerNavigation = isActive ? active : base;
    }

    return React.createElement(Button, {
      key: index,
      style: "none",
      onClick: onClick.bind(null, index),
      __containerClassName: "eds-carousel-bottom-navigation__content"
    }, innerNavigation);
  });
};

var IconBottomNavigation =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(IconBottomNavigation, _PureComponent);

  function IconBottomNavigation() {
    _classCallCheck(this, IconBottomNavigation);

    return _possibleConstructorReturn(this, _getPrototypeOf(IconBottomNavigation).apply(this, arguments));
  }

  _createClass(IconBottomNavigation, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          customNavigation = _this$props.customNavigation,
          displayIndex = _this$props.displayIndex,
          onClick = _this$props.onClick,
          totalItems = _this$props.totalItems;
      var activeIndex = displayIndex >= totalItems ? displayIndex % totalItems : displayIndex;

      var navigation = _getNavigationItems({
        customNavigation: customNavigation,
        activeIndex: activeIndex,
        totalItems: totalItems,
        onClick: onClick
      });

      return React.createElement("nav", {
        className: "eds-align--center eds-l-pad-vert-4"
      }, navigation);
    }
  }]);

  return IconBottomNavigation;
}(PureComponent);

_defineProperty(IconBottomNavigation, "propTypes", {
  displayIndex: PropTypes.number.isRequired,
  totalItems: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  customNavigation: CUSTOM_NAVIGATION_PROP_TYPE
});

export { IconBottomNavigation as default };